import { render, staticRenderFns } from "./DeveloperEditForm.vue?vue&type=template&id=3b59dfa5"
import script from "./DeveloperEditForm.vue?vue&type=script&lang=js"
export * from "./DeveloperEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports